import { IconProps } from './IconProps';

export const SupportLogo = (props: IconProps) => {
  return (
    <svg
      className={props.className}
      style={props.style}
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      fill="none"
      stroke="#000"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1"
      aria-labelledby="supportIconTitle"
      color="#000"
      viewBox="-2.4 -2.4 28.8 28.8"
    >
      <g id="SVGRepo_iconCarrier">
        <title id="supportIconTitle">Support</title>
        <path d="M21 12h-2a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h0a2 2 0 0 0 2-2v-4a9 9 0 0 0-18 0v4a2 2 0 0 0 2 2h0a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2H3" />
        <path d="M21 14v4c0 2-.667 3-2 3h-5" />
      </g>
    </svg>
  );
};

